import dayjs from 'dayjs';
import isSameString from '@/utilities/isSameString';

const formatDiscount = (discount) => {
  const {
    active,
    type,
    value,
    endDate,
    currency,
    limit,
    payments,
  } = discount;
  const percentageValue = `${value}%`;
  const amountValue = `${currency} ${value / 100}`;
  const label = (type === 'percentage') ? percentageValue : amountValue;
  const hitLimit = payments && payments.length >= limit;
  const isExpired = endDate && dayjs.unix(endDate.seconds).isBefore(dayjs());
  return {
    ...discount,
    label,
    value: parseInt(value, 10),
    limit: parseInt(limit, 10),
    isExpired,
    active: active && !isExpired && !hitLimit,
  };
};


const getDiscount = ({
  state,
  code,
  currency,
  id,
}) => {
  const { discounts } = state;
  const match = discounts && discounts.find((discount) => {
    if (id) return discount.id === id;
    const matchCurrency = currency && isSameString(discount.currency, currency);
    const matchCode = code && isSameString(discount.code, code);
    const payments = discount.payments ? discount.payments.length : 0;
    const hasUnits = discount.limit ? discount.limit > payments : true;
    const { endDate } = discount;
    const isExpired = endDate && dayjs.unix(endDate.seconds).isBefore(dayjs());
    return matchCurrency && matchCode && hasUnits && !isExpired;
  });
  return match && formatDiscount(match);
};

const getAllDiscounts = ({ state }) => {
  const { discounts } = state;
  const compare = (a, b) => b.active - a.active;
  return discounts && discounts.map(discount => formatDiscount(discount)).sort(compare);
};

export default {
  getAllDiscounts: state => getAllDiscounts({ state }),
  getDiscount: state => params => getDiscount({ state, ...params }),
};
